/*
 * @Description: 编辑岗位说明书
 * @Author: 杨志航
 * @Date: 2026-02-10 17:18:16
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  Select,
  message,
  Radio,
  Upload,
  Icon,
  Button,
  Row,
  Col,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { uploadDragger } from '@/utils/uploadDragger'
import { allTrim, filterParams } from '@/utils'

const FormItem = Form.Item
const Option = Select.Option
const { Dragger } = Upload

let draggerObj = {}

const EditJobPostFile = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue, getFieldValue } = props.form
  const { setEditVisible, getList, editData } = props
  const [saveLoading, setSaveLoading] = useState(false)
  const [jobPostFileType, setJobPostFileType] = useState(2)
  const [jobPostFileList, setJobPostFileList] = useState([])

  useEffect(() => {
    draggerObj = uploadDragger({
      accept: '.pdf',
      limitNum: 1,
      limitSize: 5,
    })
    api.getJobPostFileList({ 
      limit: global.paramsLimit 
    }).then(data => {
      setJobPostFileList(data.list)
    }).catch(err => console.log(err))
  }, [])

  useEffect(() => {
    const { fileName, fileInfo, jobPostFileId } = editData
    if (fileName) {
      if (jobPostFileType === 1) {
        setFieldsValue({
          fileInfo: [{
            uid: '-1',
            name: fileInfo.name,
            status: 'done',
            url: fileInfo.url,
          }],
          fileName,
        })
      } else {
        setFieldsValue({
          jobPostFileId,
        })
      }
    }
  }, [jobPostFileType])

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        vals.id = editData.id
        if (vals.jobPostFileIsNew === 1) {
          const { url, name } = vals.fileInfo[0]
          vals.fileInfo = { url, name }
        } else {
          vals.newJobPostFileId = vals.jobPostFileId
          delete vals.jobPostFileId
        }
        setSaveLoading(true)
        api.setStaffJobPost(vals).then(() => {
          setSaveLoading(false)
          setEditVisible(false)
          message.success('编辑成功')
          getList()
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  const onPreviewFile = () => {
    const id = getFieldValue('jobPostFileId')
    if (!id) {
      message.warning('请选择岗位说明书')
      return
    }
    const data = jobPostFileList.find(item => item.id == id)
    window.open(data.fileInfo.url, '_blank')
  }

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="事业群名称">
          {editData.groupName || '--'}
        </FormItem>
        <FormItem label="部门名称">
          {editData.departmentName || '--'}
        </FormItem>
        <FormItem label="岗位名称">
          {editData.name || '--'}
        </FormItem>
        <FormItem label="岗位说明书" required>
          {getFieldDecorator('jobPostFileIsNew', {
            initialValue: 2,
          })(
            <Radio.Group onChange={evt => setJobPostFileType(evt.target.value)} >
            <Radio value={2}>选择已有岗位说明书</Radio>
            <Radio value={1}>上传新增岗位说明书</Radio>
          </Radio.Group>)}
        </FormItem>
        {jobPostFileType === 1 ? (
          <>
            <Form.Item wrapperCol={{ span: 18, offset: 6 }}>
              {getFieldDecorator('fileInfo', {
                valuePropName: 'fileList',
                getValueFromEvent: draggerObj.normFile,
                rules: [{ required: true, message: '请上传岗位说明书' }]
              })(
                <Dragger {...draggerObj}>
                  <p className="ant-upload-drag-icon">
                    <Icon type="inbox" />
                  </p>
                  <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                  <p className="ant-upload-hint">
                    支持扩展名：.pdf
                  </p>
                </Dragger>
              )}
            </Form.Item>
            <FormItem label="岗位说明书名称">
              {getFieldDecorator('fileName', {
                rules: [{ required: true, message: '请输入岗位说明书名称' }]
              })(
                <Input placeholder="请输入岗位说明书名称" maxLength={50} />
              )}
            </FormItem>
          </>
        ) : (
          <>
            <FormItem wrapperCol={{ span: 18, offset: 6 }}>
              <Row gutter={8}>
                <Col span={16}>
                  {getFieldDecorator('jobPostFileId', {
                    rules: [{ required: true, message: '请选择岗位说明书' }]
                  })(
                    <Select 
                      placeholder="请选择岗位说明书"
                      showSearch
                      optionFilterProp="children"
                    >
                      {jobPostFileList.map(item => <Option key={item.id} value={item.id}>{item.fileName}</Option>)}
                    </Select>
                  )}
                </Col>
                <Col span={8}>
                  <Button type="primary" onClick={onPreviewFile}>岗位说明书预览</Button>
                </Col>
              </Row>
            </FormItem>
          </>
        )}
        <BtnGroup onCancel={() => setEditVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  );
}

export default Form.create()(EditJobPostFile)
